(function () {
  const HUBSPOT_ROOT_SELECTOR = [
    '.shopify-hubspot-form',
    '.hs-form-frame',
    '.hs-form-html',
    '[data-hs-forms-root]',
    'form.hs-form',
    'form[data-form-id]',
  ].join(',');

  const FIELD_SELECTOR = [
    'input:not([type="checkbox"]):not([type="radio"]):not([type="submit"]):not([type="button"]):not([type="hidden"])',
    'select',
    'textarea',
  ].join(',');

  const SUBMIT_SELECTOR = ['input[type="submit"]', 'button[type="submit"]', '.hs-button', '.hsfc-Button'].join(',');

  const OBSERVER_MAX_MS = 120000;
  const OBSERVER_IDLE_MS = 4000;
  const OBSERVER_POLL_MS = 400;

  function isHubSpotRoot(root) {
    if (!root || root.nodeType !== Node.ELEMENT_NODE) return false;

    if (
      root.matches('.shopify-hubspot-form, .hs-form-frame, .hs-form-html, [data-hs-forms-root], form.hs-form')
    ) {
      return true;
    }

    return Boolean(root.querySelector('.hs-form, .hs-form-field, .hs-input, .hsfc-Step, [data-hsfc-id]'));
  }

  function applyFieldClasses(scope) {
    if (!scope || !scope.querySelectorAll) return;

    scope.querySelectorAll(FIELD_SELECTOR).forEach((field) => {
      if (field.matches('input[type="tel"]') && field.closest('.hsfc-PhoneInput')) return;

      field.classList.add('form-control');

      if (field.tagName === 'TEXTAREA') {
        field.classList.add('form-control--textarea');
      }

      if (field.tagName === 'SELECT') {
        field.classList.add('form-control--select');
      }
    });

    scope.querySelectorAll(SUBMIT_SELECTOR).forEach((button) => {
      button.classList.add('btn', 'btn--primary');
    });
  }

  function flagIframeHost(root) {
    if (!root || !root.querySelector) return;

    const iframe = root.querySelector(
      'iframe[src*="hsforms.net"], iframe[src*="hubspot.com"], iframe[src*="hubspotusercontent"]'
    );

    if (iframe) {
      root.setAttribute('data-hubspot-host', 'iframe');
    }
  }

  function stripHsfcRichTextInlineFonts(scope) {
    if (!scope || !scope.querySelectorAll) return;

    scope.querySelectorAll('.hsfc-RichText [style], [data-hsfc-id="RichText"] [style]').forEach((el) => {
      el.style.removeProperty('font-family');
    });
  }

  function stripHsfcRichTextInlineFontsDeep(scope) {
    if (!scope || !scope.querySelectorAll) return;

    stripHsfcRichTextInlineFonts(scope);
    scope.querySelectorAll('*').forEach((el) => {
      if (el.shadowRoot) stripHsfcRichTextInlineFontsDeep(el.shadowRoot);
    });
  }

  //Hardcode check for interested in label
  const INTERESTED_IN_LABEL_PATTERN = /^what\s+are\s+you\s+interested\s+in\??$/i;

  function normalizeInterestedInLabel(scope) {
    if (!scope?.querySelectorAll) return;

    scope
      .querySelectorAll('label, legend, [data-hsfc-id="FieldLabel"], .hsfc-FieldLabel')
      .forEach((el) => {
        const text = el.textContent.replace(/\s+/g, ' ').trim();
        if (INTERESTED_IN_LABEL_PATTERN.test(text)) {
          el.textContent = 'What are you interested in?';
          el.classList.add('hubspot-label-sentence-case');
        } else {
          el.classList.remove('hubspot-label-sentence-case');
        }
      });

    scope.querySelectorAll('*').forEach((el) => {
      if (el.shadowRoot) normalizeInterestedInLabel(el.shadowRoot);
    });
  }

  function addClasses(root) {
    if (!isHubSpotRoot(root)) return false;

    root.classList.add('shopify-hubspot-form');

    applyFieldClasses(root);

    root.querySelectorAll('*').forEach((el) => {
      if (el.shadowRoot) applyFieldClasses(el.shadowRoot);
    });

    stripHsfcRichTextInlineFontsDeep(root);
    normalizeInterestedInLabel(root);

    flagIframeHost(root);

    return true;
  }

  function syncHubSpotForms(scope) {
    if (scope && scope !== document && scope.nodeType !== Node.ELEMENT_NODE) return false;

    const searchRoot = scope && scope.nodeType === Node.ELEMENT_NODE ? scope : document;
    let found = false;

    if (searchRoot.matches?.(HUBSPOT_ROOT_SELECTOR)) {
      found = addClasses(searchRoot) || found;
    }

    searchRoot.querySelectorAll?.(HUBSPOT_ROOT_SELECTOR).forEach((root) => {
      found = addClasses(root) || found;
    });

    return found;
  }

  function startObserver() {
    if (!document.body) return;

    let lastHubSpotActivity = Date.now();
    let hasSyncedHubSpot = false;

    const touchActivity = () => {
      lastHubSpotActivity = Date.now();
    };

    const observer = new MutationObserver((mutations) => {
      let hubspotMutation = false;
      let sawHubSpotAsset = false;

      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (node.tagName === 'LINK' && node.href && node.href.includes('hsforms.net')) {
              sawHubSpotAsset = true;
            }
            if (node.tagName === 'STYLE' && node.id && String(node.id).startsWith('hs-form-style')) {
              sawHubSpotAsset = true;
            }
          }
          if (syncHubSpotForms(node)) hubspotMutation = true;
        });
      });

      if (sawHubSpotAsset) {
        stripHubSpotInjectedStyles();
        syncHubSpotForms(document);
      }

      if (hubspotMutation) {
        hasSyncedHubSpot = true;
        touchActivity();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    const started = Date.now();

    const poll = window.setInterval(() => {
      stripHubSpotInjectedStyles();

      if (syncHubSpotForms(document)) {
        hasSyncedHubSpot = true;
        touchActivity();
      }

      const elapsed = Date.now() - started;
      const idle = Date.now() - lastHubSpotActivity > OBSERVER_IDLE_MS;

      if (elapsed >= OBSERVER_MAX_MS || (hasSyncedHubSpot && idle)) {
        window.clearInterval(poll);
        observer.disconnect();
      }
    }, OBSERVER_POLL_MS);
  }

  function stripHubSpotInjectedStyles() {
    document.querySelectorAll('style[id^="hs-form-style"]').forEach((node) => node.remove());
    document.querySelectorAll('link[rel="stylesheet"][href*="hsforms.net"]').forEach((node) => node.remove());
  }

  function isHubSpotPostMessageOrigin(origin) {
    if (typeof origin !== 'string') return false;
    return (
      origin.includes('hsforms.net') ||
      origin.includes('hubspot.com') ||
      origin.includes('hubspotusercontent.net')
    );
  }

  function bindHubSpotFormReadyCleanup() {
    window.addEventListener('message', (event) => {
      if (!isHubSpotPostMessageOrigin(event.origin)) return;
      if (!event.data || event.data.type !== 'hsFormCallback') return;
      if (event.data.eventName !== 'onFormReady') return;

      stripHubSpotInjectedStyles();
      syncHubSpotForms(document);
    });
  }

  function scheduleDeferredHubSpotStyleCleanup() {
    [100, 800, 2500].forEach((ms) => {
      window.setTimeout(() => {
        stripHubSpotInjectedStyles();
        syncHubSpotForms(document);
      }, ms);
    });
  }

  function init() {
    bindHubSpotFormReadyCleanup();
    syncHubSpotForms(document);
    scheduleDeferredHubSpotStyleCleanup();
    startObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
